// extracted by mini-css-extract-plugin
module.exports = {"text":"style_text__PPqCV","light":"style_light__HI_a2"};